
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("b9zqQ", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $81ec050ab36f3ad2$export$2cd8252107eb640b; });

var $jG4hL = parcelRequire("jG4hL");

var $80tmL = parcelRequire("80tmL");
const $81ec050ab36f3ad2$export$2cd8252107eb640b = ()=>{
    let attempts = 0;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(".link.link--modal").length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))("#link-modal").length == 0) (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))("main").append('<div id="link-modal" class="modal fade" tabindex="-1" role="dialog">\n    <div class="modal-dialog modal-xl" role="document">\n        <div class="modal-content">\n            <div class="modal-header">\n                <div></div>\n                <button class="btn btn--close" type="button" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">\xd7</span></button>\n            </div>\n            <div id="link-modal-content" class="modal-body standard-modal"></div>\n        </div>\n    </div>\n</div>');
    (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(".link.link--modal").each(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(this).attr("data-bs-toggle", "modal");
        (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(this).attr("data-bs-target", "#link-modal");
        let href = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(this).attr("href");
        if (href.endsWith("/")) href = href.slice(0, -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(this).attr("data-url", `${window.location.origin}${href}?type=1332`);
        (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(this).attr("href", "javascript:void(0);");
    });
    let modalElementList = document.querySelectorAll(".modal");
    [
        ...modalElementList
    ].map((modal)=>new (0, $80tmL.Modal)(modal));
    // if document.ready needed
    const whenComplete = ()=>{
        if (attempts > 30) return;
        attempts += 1;
        if (document.readyState === "complete") {
            let linkModal = document.getElementById("link-modal");
            linkModal.addEventListener("show.bs.modal", (event)=>{
                // Button that triggered the modal
                let link = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(event.relatedTarget);
                // Extract info from data-* attributes
                let ajaxUrl = link.data("url");
                (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL))).ajax({
                    url: ajaxUrl,
                    context: document.body
                }).done(function(data) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))("#link-modal-content").html(data);
                    (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))("#link-modal-content").find(".collapse").each(function() {
                        let $this = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(this);
                        if (!$this.hasClass("show")) $this.parent().find(".panel-info__btn > [data-bs-toggle]").addClass("collapsed");
                    });
                }).fail(function() {
                    console.warn("Error. Couldn't get data from server.");
                });
            });
        } else setTimeout(function() {
            whenComplete();
        }, 400);
    };
    whenComplete();
};

});

parcelRegister("jHMUv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e587f90d126edbfb$export$581ff339ea0ba762; });

var $5gKb4 = parcelRequire("5gKb4");
function $e587f90d126edbfb$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $5gKb4._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("5gKb4", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $3d624443cd99befe$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $3d624443cd99befe$export$1e71eb4bef00f6b0; });
function $3d624443cd99befe$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("hYccX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d15182816097eec3$export$4fa2f4023c9cbda5; });
function $d15182816097eec3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d15182816097eec3$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $d15182816097eec3$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});


//# sourceMappingURL=link-modal.module.99fc746d.js.map
